var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3583_363)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6799 8.4C14.6799 9.46 14.3799 10.45 13.8299 11.29C13.7899 11.37 13.7399 11.44 13.6899 11.51C12.7299 12.89 11.1199 13.8 9.31995 13.8C6.35995 13.8 3.94995 11.38 3.94995 8.4C3.94995 5.42 6.35995 3 9.31995 3C11.1299 3 12.7399 3.91 13.6899 5.29C13.7399 5.36 13.7899 5.43 13.8299 5.52C14.3799 6.36 14.6799 7.35 14.6799 8.41V8.4Z",
    stroke: "#E5EAF9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5001 8.39998C20.5001 10.6 18.7301 12.38 16.5501 12.38C15.5001 12.38 14.5501 11.97 13.8401 11.29C14.3901 10.45 14.6901 9.45998 14.6901 8.39998C14.6901 7.33998 14.3901 6.34998 13.8401 5.50998C14.5501 4.82998 15.5001 4.41998 16.5501 4.41998C18.7301 4.41998 20.5001 6.19998 20.5001 8.39998Z",
    stroke: "#E5EAF9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 20.9999C6.11 16.5799 12.46 16.5599 15.1 20.9499L15.13 20.9999",
    stroke: "#E5EAF9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.16 20.0999C18.74 18.6399 17.74 17.4999 16.48 17.0099L17.67 15.8199",
    stroke: "#E5EAF9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3583_363"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/Users.5e23531bce187a93eff735795a195176.svg";
export { ForwardRef as ReactComponent };